import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPauseStyle0 = cosmosIconCss;

const CosmosIconPause$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPause extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2f1c99152061463d79ca9c05254b30213eccd284', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '25702d1d3710e7aa63bf4fbe46ee98ae57d95099', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '286ad31d46242ba8be150f8c708a7c85ceb09255', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm8 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPauseStyle0; }
}, [1, "cosmos-icon-pause", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pause"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pause":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPause$1);
            }
            break;
    } });
}

const CosmosIconPause = CosmosIconPause$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPause, defineCustomElement };
